@for (product of mappedProducts(); track product) {
  <ui-product-card
    [displayListView]="false"
    [showActions]="true"
    [position]="$index"
    [product]="product">
  </ui-product-card>
}
